import React from 'react';
import BusinessIcon from '@mui/icons-material/Business';
import { Box, Chip, CircularProgress } from '@mui/material';
import { InvestmentEntity } from '../../../models/InvestmentEntity';
import { entityIcon } from './contactPortfolioEntityIcon';
import ContactPortfolioSectionCard from './ContactPortfolioSectionCard';

export default function ContactPortfolioEntitiesSection({
  entities,
  loading,
}: {
  entities: InvestmentEntity[];
  loading: boolean;
}) {
  if (!loading && entities.length === 0) return null;

  return (
    <ContactPortfolioSectionCard
      title="Investment Entities"
      icon={<BusinessIcon sx={{ fontSize: 18, color: 'text.secondary' }} />}
      loading={loading}
    >
      {loading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
          <CircularProgress size={20} />
        </Box>
      )}
      {!loading && (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {entities.map((e) => (
            <Chip
              key={e.id}
              icon={entityIcon(e.type)}
              label={e.name}
              size="small"
              variant="outlined"
              color={e.isOwner ? 'success' : 'default'}
              title={`${e.type}${e.isOwner ? ' · Owner' : ' · Representative'}`}
            />
          ))}
        </Box>
      )}
    </ContactPortfolioSectionCard>
  );
}
